import React from 'react';
const points = [{
  num: '01',
  title: 'Søndag eftermiddag = Angst.',
  desc: 'Du ofrer din hvile for at finde på nye øvelser, så du ikke gentager det samme hver mandag.'
}, {
  num: '02',
  title: 'Arbejdet stopper aldrig.',
  desc: 'Efter skole eller job kommer du hjem med den mentale byrde at skulle forberede morgendagens træning.'
}, {
  num: '03',
  title: 'Spillere der går i stå.',
  desc: 'Du føler, at du mangler værktøjer til, at de ser reelle resultater i deres teknik og flow.'
}, {
  num: '04',
  title: 'Du søger anerkendelse.',
  desc: 'Du vil være træneren, der præsenterer et topmoderne og professionelt program i din klub.'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 relative overflow-hidden" data-id="element-136">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-137"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-138">
        <div className="text-center mb-12" data-id="element-139">
          <span className="inline-block text-primary font-bold text-sm tracking-widest uppercase mb-3" data-id="element-140">
            👀 Genkender du disse scener?
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-141">
            Håndbold Klar er til dig,{' '}
            <span className="text-primary" data-id="element-142">hvis du oplever dette:</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5" data-id="element-143">
          {points.map((point, i) => <div key={i} className="flex items-start gap-5 bg-bg-alt/80 backdrop-blur-sm rounded-2xl p-6 border border-border-light hover:border-primary/50 transition-all group shadow-lg hover:-translate-y-1" data-id="element-144">
              <div className="text-primary/30 group-hover:text-primary font-black text-3xl sm:text-4xl flex-shrink-0 transition-colors tracking-tighter" data-id="element-145">
                {point.num}
              </div>
              <div className="flex-1" data-id="element-146">
                <h3 className="text-text-main text-lg sm:text-xl font-bold leading-snug mb-2" data-id="element-147">
                  {point.title}
                </h3>
                <p className="text-text-sec text-sm sm:text-base leading-relaxed" data-id="element-148">
                  {point.desc}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-149">
          <p className="text-text-main text-lg sm:text-xl font-bold mb-6" data-id="element-150">
            ✋ Genkender du dig selv? Så er dette kit præcis til dig.
          </p>
          <a href="#pricing" className="inline-block bg-cta-green text-white font-black text-base sm:text-xl px-8 sm:px-10 py-4 rounded-2xl hover:bg-cta-green-hover transition-all shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/10" data-id="element-151">
            🚀 JEG VIL HAVE MIN TID TILBAGE
          </a>
        </div>
      </div>
    </section>;
}